import { products } from "../../../mocks/products";

const productDetails = [
  "Sourced from trusted certified farmers & suppliers",
  "Proper cleaning and multi-stage grading process",
  "Hygienic processing in clean facilities",
  "Export-standard packaging for safe transit",
  "Suitable for bulk buyers and food industry",
];

export default function Products() {
  return (
    <section id="products" className="py-20 md:py-28 bg-[#F7FAF8]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
            Our Range
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Premium Export Products
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            From the fertile soils of Northeast India — authentic, export-grade agricultural products for global buyers.
          </p>
        </div>

        {/* Product Cards */}
        <div data-product-shop className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              {/* Image */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <span className="inline-block text-xs font-semibold text-[#2D6A4F] bg-[#D8F3DC] px-2.5 py-0.5 rounded-full mb-2">
                  {product.origin}
                </span>
                <h3 className="text-base font-bold text-[#1B4332] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {product.name}
                </h3>
                <p className="text-xs text-gray-500 leading-relaxed mb-4">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-400">
                    <span className="w-3 h-3 inline-flex items-center justify-center text-[#C9A227] mr-1">
                      <i className="ri-box-3-line"></i>
                    </span>
                    MOQ: {product.moq}
                  </span>
                  <button
                    onClick={() => {
                      window.open(`https://wa.me/917584050023?text=Hello%20Pandit%20Export%2C%20I%20am%20interested%20in%20${encodeURIComponent(product.name)}.%20Please%20share%20more%20details.`, "_blank");
                    }}
                    className="flex items-center gap-1 text-[#C9A227] hover:text-[#b8911e] text-xs font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Enquire
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Product Details / Quality Section */}
        <div id="quality" className="mt-20 bg-white rounded-3xl overflow-hidden border border-gray-100">
          <div className="flex flex-col lg:flex-row">
            {/* Left Image */}
            <div className="w-full lg:w-[42%] flex-shrink-0">
              <div className="h-72 lg:h-full min-h-[320px] overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/f02efb466250559b5cddafb864d71e39.jpg"
                  alt="Quality Processing"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="w-full lg:w-[58%] p-8 md:p-12 flex flex-col justify-center">
              <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4 self-start">
                Our Standards
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Quality from Source to Delivery
              </h3>
              <p className="text-gray-500 text-base leading-relaxed mb-8">
                Every product we export goes through a rigorous multi-stage quality process. We believe in delivering exactly what we promise — premium quality, every single time.
              </p>
              <ul className="space-y-4">
                {productDetails.map((detail, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#D8F3DC] text-[#2D6A4F] flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-gray-600 text-sm leading-relaxed">{detail}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                className="mt-8 inline-flex items-center gap-2 border-2 border-[#2D6A4F] text-[#2D6A4F] hover:bg-[#2D6A4F] hover:text-white font-semibold px-6 py-3 rounded-full transition-all duration-200 self-start cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-file-list-3-line"></i>
                </span>
                Request Quality Info
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
